// extracted by mini-css-extract-plugin
export default {"table":"EwfqB8kZohO7VngSvuEA"};